import AppHeadingDto, { ContentDto } from "dto/components/app-heading-dto";

const AppHeading = ({ title, children }: AppHeadingDto) => {
	return (
		<div className="app-heading">
			<h1 className="heading__header">{title}</h1>

			{children}
		</div>
	);
};

const Content = ({ children }: ContentDto) => {
	return <h4 className="heading__content">{children}</h4>;
};

const Divider = () => {
	return <div className="heading__divider"></div>;
};

AppHeading.Content = Content;
AppHeading.Divider = Divider;

export default AppHeading;
